// react, redux
import React from "react"
import { render } from "react-dom"
import { Provider } from "react-redux"
// app
import store from "./store.js"
import Router from "./router.js"


render(
    <Provider store={ store }>
        <Router />
    </Provider>,
    document.getElementById("root")
)


/** WEBPACK FOOTER **
 ** ./src/index.js
 **/